import { Component, OnInit, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
    selector: 'snackbar-notification',
    templateUrl: './snackbar-notification.component.html',
    styleUrls: ['./snackbar-notification.component.scss'],
    standalone: false
})
export class SnackbarNotificationComponent implements OnInit {
  text = '';
  useInnerHtml = false;
  snackBarRef = inject(MatSnackBarRef);
  data: any = inject(MAT_SNACK_BAR_DATA);

  constructor() { }

  ngOnInit(): void {
    this.text = this.data.text;
    this.useInnerHtml = this.data.useInnerHtml;
  }

}
